module.exports = __webpack_public_path__ + "static/media/zr_2_10.2c0c03dc.png";